module.exports = new __parcel__URL__("ef-logo.dc58863f.svg").toString();